export var EStarTheme = /*#__PURE__*/function (EStarTheme) {
  EStarTheme["Fillable"] = "fillable";
  EStarTheme["Filled"] = "filled";
  EStarTheme["NotFilled"] = "notFilled";
  return EStarTheme;
}({});
export var EStarSize = /*#__PURE__*/function (EStarSize) {
  EStarSize["S"] = "s";
  EStarSize["M"] = "m";
  return EStarSize;
}({});